/* ============================================================
   ECADRA — Core JS (المرحلة 1)
   vanilla خالص · صفر مكتبات · defer
   المكونات: announcement carousel · desktop nav · mobile menu · cart drawer (AJAX)
   ============================================================ */
(function () {
  'use strict';
  var E = window.ECADRA || {};
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- helpers ---------- */
  function qs(s, c) { return (c || document).querySelector(s); }
  function qsa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function trapFocus(panel) {
    var focusables = qsa('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])', panel);
    if (!focusables.length) return function () {};
    var first = focusables[0], last = focusables[focusables.length - 1];
    function onKey(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    panel.addEventListener('keydown', onKey);
    return function () { panel.removeEventListener('keydown', onKey); };
  }

  /* ============================================================
     1) Announcement bar — تدوير الرسائل
     ============================================================ */
  qsa('[data-announcement]').forEach(function (bar) {
    var items = qsa('.announcement-bar__item', bar);
    if (items.length < 2) return;
    var i = 0, interval = parseInt(bar.dataset.interval || '5', 10) * 1000, timer = null;
    function show(n) {
      items[i].classList.remove('is-active');
      i = (n + items.length) % items.length;
      items[i].classList.add('is-active');
    }
    function start() { if (timer) clearInterval(timer); timer = setInterval(function () { show(i + 1); }, interval); }
    var prev = qs('[data-announcement-prev]', bar);
    var next = qs('[data-announcement-next]', bar);
    if (prev) prev.addEventListener('click', function () { show(i - 1); start(); });
    if (next) next.addEventListener('click', function () { show(i + 1); start(); });
    bar.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    bar.addEventListener('mouseleave', start);
    start();
  });

  /* ============================================================
     2) Desktop nav — فتح بالكليك (زي اللايف) + Escape + كليك برّه
     ============================================================ */
  var navItems = qsa('.e-nav__item[data-has-children]');
  function closeAllNav(except) {
    navItems.forEach(function (it) {
      if (it !== except) {
        it.classList.remove('is-open');
        var btn = qs('[data-nav-toggle]', it);
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }
    });
  }
  /* قياس أسفل الهيدر عشان الميجا (full-width) تظهر تحته بالظبط */
  function setHeaderBottom() {
    var hw = qs('.e-header-wrap');
    if (!hw) return;
    var rect = hw.getBoundingClientRect();
    document.documentElement.style.setProperty('--header-bottom', Math.max(0, rect.bottom) + 'px');
  }
  setHeaderBottom();
  window.addEventListener('resize', setHeaderBottom);
  window.addEventListener('scroll', setHeaderBottom, { passive: true });

  var navEl = qs('.e-nav');
  var triggerPref = navEl ? (navEl.getAttribute('data-submenu-trigger') || 'hover') : 'hover';
  var hoverCapable = triggerPref === 'hover' && window.matchMedia('(hover: hover) and (min-width: 1024px)').matches;
  var hoverTimer = null;
  navItems.forEach(function (item) {
    var btn = qs('[data-nav-toggle]', item);
    if (!btn) return;
    /* كليك (للموبايل/التابلت + fallback) */
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      closeAllNav(item);
    });
    /* hover ذكي على الديسكتوب: فتح فوري + قفل بتأخير صغير */
    if (hoverCapable) {
      item.addEventListener('mouseenter', function () {
        clearTimeout(hoverTimer);
        closeAllNav(item);
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () {
          item.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
        }, 180);
      });
    }
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.e-nav')) closeAllNav();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllNav();
  });

  /* ============================================================
     2b) User dropdown / sheet — data-user-toggle
     ============================================================ */
  var userWrap = qs('[data-user-menu]');
  if (userWrap) {
    var userBtn = qs('[data-user-toggle]', userWrap);
    userBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var open = userWrap.classList.toggle('is-open');
      userBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-user-menu]')) {
        userWrap.classList.remove('is-open');
        userBtn.setAttribute('aria-expanded', 'false');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        userWrap.classList.remove('is-open');
        userBtn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ============================================================
     3) Drawers عامة (mobile menu + cart) — data-drawer-open="id"
     ============================================================ */
  var openDrawer = null, releaseTrap = null, lastTrigger = null;
  function drawerOpen(id, trigger) {
    var d = document.getElementById(id);
    if (!d) return;
    drawerClose();
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    openDrawer = d; lastTrigger = trigger || null;
    var panel = qs('.e-drawer__panel, .e-mobile-menu__panel', d) || d;
    releaseTrap = trapFocus(panel);
    var closeBtn = qs('[data-drawer-close]', d);
    if (closeBtn) closeBtn.focus();
  }
  function drawerClose() {
    if (!openDrawer) return;
    openDrawer.classList.remove('is-open');
    openDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (releaseTrap) releaseTrap();
    if (lastTrigger) lastTrigger.focus();
    openDrawer = null; releaseTrap = null; lastTrigger = null;
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); drawerOpen(opener.dataset.drawerOpen, opener); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); drawerClose(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') drawerClose();
  });

  /* ============================================================
     4) Cart drawer — AJAX (تغيير كمية/مسح + إعادة رندر بالـ Section Rendering API)
     ============================================================ */
  function money(cents) {
    var fmt = (E.moneyFormat || '{{amount}}');
    var amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }
  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }
  function rerenderCartDrawer() {
    return fetch((E.routes.root || '/') + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = qs('[data-cart-drawer-inner]', tmp);
        var current = qs('[data-cart-drawer-inner]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      });
  }
  function cartChange(line, quantity) {
    var drawer = document.getElementById('CartDrawer');
    if (drawer) drawer.setAttribute('aria-busy', 'true');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return rerenderCartDrawer();
      })
      .finally(function () {
        if (drawer) drawer.removeAttribute('aria-busy');
      });
  }
  document.addEventListener('click', function (e) {
    var qty = e.target.closest('[data-cart-qty]');
    if (qty) {
      e.preventDefault();
      cartChange(parseInt(qty.dataset.line, 10), parseInt(qty.dataset.cartQty, 10));
      return;
    }
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) {
      e.preventDefault();
      cartChange(parseInt(rm.dataset.line, 10), 0);
    }
  });

  /* أي إضافة للكارت من باقي الموقع (مراحل جاية) هتنادي الإيفنت ده */
  document.addEventListener('ecadra:cart:added', function (e) {
    var count = e.detail && e.detail.item_count;
    if (typeof count === 'number') updateCartCount(count);
    rerenderCartDrawer().then(function () { drawerOpen('CartDrawer'); });
  });

  window.ECADRA = E;
  E.money = money;
  E.drawerOpen = drawerOpen;
  E.drawerClose = drawerClose;
})();

/* ============================================================
   Reveal on scroll — لكل عنصر فيه [data-reveal]
   ============================================================ */
(function () {
  var els = document.querySelectorAll('[data-reveal]');
  if (!els.length) return;

  function revealAll() {
    els.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* في وضع التصميم (Customize) أو غياب الـ Observer: أظهر كله فوراً */
  if (window.Shopify && window.Shopify.designMode) { revealAll(); return; }
  if (!('IntersectionObserver' in window)) { revealAll(); return; }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
  els.forEach(function (el) { io.observe(el); });

  /* أمان: لو حصل أي شيء ومنعش الظهور خلال 1.2 ثانية، أظهر الكل */
  setTimeout(function () {
    els.forEach(function (el) {
      if (!el.classList.contains('is-in')) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) el.classList.add('is-in');
      }
    });
  }, 1200);
})();

/* ============================================================
   Hot Deals slider — أزرار التنقّل
   ============================================================ */
(function () {
  var sliders = document.querySelectorAll('.e-deals');
  if (!sliders.length) return;
  sliders.forEach(function (root) {
    var track = root.querySelector('[data-deals-track]');
    var prev = root.querySelector('[data-deals-prev]');
    var next = root.querySelector('[data-deals-next]');
    if (!track) return;

    function step() {
      var slide = track.querySelector('.e-deals__slide');
      var w = slide ? slide.getBoundingClientRect().width : 240;
      return (w + 18) * 2; // يتحرّك سلايدتين في المرة
    }
    function update() {
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    update();
  });
})();

/* ============================================================
   Try-On compare slider — سحب الخط لكشف قبل/بعد
   ============================================================ */
(function () {
  function initCompare(box) {
    if (box._compareInit) return;
    box._compareInit = true;
    var inner = box.querySelector('.e-tryon__compare-inner');
    var before = box.querySelector('[data-compare-before]');
    var handle = box.querySelector('[data-compare-handle]');
    var range = box.querySelector('[data-compare-range]');
    if (!inner || !before || !handle || !range) return;

    function setBoxWidth() {
      inner.style.setProperty('--to-box-w', inner.clientWidth + 'px');
    }
    function setPos(v) {
      var p = Math.max(0, Math.min(100, v));
      before.style.width = p + '%';
      handle.style.insetInlineStart = p + '%';
    }
    setBoxWidth();
    setPos(parseFloat(range.value) || 50);
    range.addEventListener('input', function () { setPos(parseFloat(range.value)); });

    /* إعادة الحساب لما أي صورة تخلص تحميل (مهم عند تغيير الصورة) */
    box.querySelectorAll('img').forEach(function (img) {
      if (img.complete) { setBoxWidth(); }
      img.addEventListener('load', setBoxWidth);
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(setBoxWidth).observe(inner);
    } else {
      window.addEventListener('resize', setBoxWidth);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-compare]').forEach(initCompare);
  }
  initAll();

  /* في وضع الـ Customize: أعد التهيئة عند تحميل/تبديل السكاشن */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:section:select', initAll);
  }
})();